import { FC } from 'react';
import SuperUpload from '../SuperUpload';
import SimpleFormItem from './subpage/simpleFormItem';
import { BaseSimpleFormProps, SimpleFormItemEnum } from './interface';
import { UploadImageProps } from '../SuperUpload/uploadImage';

export interface SimpleFormUploadImageProps extends BaseSimpleFormProps {
  uploadImageProps?: UploadImageProps;
}
const simpleFormUploadImage: FC<SimpleFormUploadImageProps> = props => {
  const { uploadImageProps, style, ...restProps } = props;
  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  return (
    <SimpleFormItem
      valuePropName="fileList"
      getValueFromEvent={normFile}
      {...restProps}
    >
      <SuperUpload style={style} {...uploadImageProps} />
    </SimpleFormItem>
  );
};

simpleFormUploadImage.displayName = SimpleFormItemEnum.SimpleFormUploadImage;

export default simpleFormUploadImage;
